import { render, staticRenderFns } from "./annualBarChart.vue?vue&type=template&id=0c8764c5&scoped=true"
import script from "./annualBarChart.vue?vue&type=script&lang=js"
export * from "./annualBarChart.vue?vue&type=script&lang=js"
import style0 from "./annualBarChart.vue?vue&type=style&index=0&id=0c8764c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8764c5",
  null
  
)

export default component.exports